
const FakeOrderItem = [
    {
      id: 1,
      name: "SUSTRATO GROWMIX TERRAFERTIL",
      category: "Sustrato y Complementos",
      price: 2300,
      images: "https://d3ugyf2ht6aenh.cloudfront.net/stores/001/220/151/products/diseno-sin-titulo1-1f5611561891399a3116249850976584-1024-1024.png",
       
      order_id:1,
      quantity: 3,
      created_at: "02.01.2015 19:47",
      modified_at: "02.02.2015 19:47",
    },
    {
      id: 2,
      name: "SUSTRATO PREMIUM CULTIVATE",
      category: "Sustrato y Complementos",
      price: 2300,
      images: "https://d3ugyf2ht6aenh.cloudfront.net/stores/001/220/151/products/dsc_39281-358e7a4a60ef8c34bf16249928104488-1024-1024.jpg",
      
      order_id:2,
      quantity: 5,
      created_at: "02.01.2015 19:47",
      modified_at: "02.02.2015 19:47",
    },
    {
      id: 3,
      name: "MINI BONG D&K 2",
      category: "Pipas y Bongs",
      price: 2090,
      images:"https://d3ugyf2ht6aenh.cloudfront.net/stores/001/220/151/products/img_05861-8893e402f5cc0cb41f15963022814921-1024-1024.jpg",
       
      order_id:2,
      quantity: 1,
      created_at: "02.01.2015 19:47",
      modified_at: "02.02.2015 19:47",
    },
    {
      id: 4,
      name: "PIPA INDIA MADERA",
      category: "Pipas y Bongs",
      price: 790,
      images: "https://d3ugyf2ht6aenh.cloudfront.net/stores/001/220/151/products/diseno-sin-titulo-221-15083a7697f3b9f8b416182543233238-1024-1024.png",
      order_id:1,
      quantity: 5,
      created_at: "02.01.2015 19:47",
      modified_at: "02.02.2015 19:47",
    },
    {
      id: 5,
      name: "MACETAS MAD ROCKET INTELIGENTES",
      category: "Mad Rocket",
      price: 810,
      images:  "https://d3ugyf2ht6aenh.cloudfront.net/stores/001/220/151/products/mad-rocket-10-lts-maceta-inteligente-x-4-unidades-d_nq_np_714722-mla32728464099_112019-f1-2e0adf9582f7cb878115989092464678-1024-1024.jpg",
      
      order_id:1,
      quantity: 1,
      created_at: "02.01.2015 19:47",
      modified_at: "02.02.2015 19:47",
    },
    {
      id: 6,
      name: "PERLITA",
      category: "Sustrato y Complementos",
      price: 30,
      images:  "https://d3ugyf2ht6aenh.cloudfront.net/stores/001/220/151/products/que-es-la-perlita-para-plantas1-3e4325f10a4ebf334716293097372885-1024-1024.jpg",
      order_id:2,
      quantity: 3,
      created_at: "02.01.2015 19:47",
      modified_at: "02.02.2015 19:47",
    },
  ];
  
  export default FakeOrderItem;
  